export default __webpack_public_path__ + "static/media/Blue_Player_Podium_min.7e439360.png";